export const SUPER_ADMIN_PERMISSION = '*:*:*'
export const SUPER_ADMIN_ROLE = 'admin'

export function normalizePermissions(value) {
  if (!value) return []
  return Array.isArray(value) ? value : [value]
}

export function hasPermission(required, context = {}) {
  const requiredList = normalizePermissions(required)
  if (requiredList.length === 0) return true

  const permissions = Array.isArray(context.permissions) ? context.permissions : []
  const roleKeys = Array.isArray(context.roleKeys) ? context.roleKeys : []

  if (permissions.includes(SUPER_ADMIN_PERMISSION) || roleKeys.includes(SUPER_ADMIN_ROLE)) {
    return true
  }
  return requiredList.some(item => permissions.includes(item))
}
